<template>
  <van-cell-group>
    <p class="text3Indentation">
      <van-steps :active="active">
        <van-step>机构邀请</van-step>
        <van-step>个人信息</van-step>
        <van-step>补充调研</van-step>
      </van-steps>
    </p>
  </van-cell-group>
  <van-divider :style="{ color: '#EA6853', borderColor: '#EA6853', padding: '0 16px' }"></van-divider>
  <van-cell-group inset>
  <van-form @submit="onSubmit">
    <van-notice-bar
    wrapable :scrollable="false" 
                left-icon="volume-o">
              <p class="text2Indentation">服务只想指定客户邀约开放，请您输入邀请码</p>
            </van-notice-bar>
    <van-field
                v-model="registerData.nowHospCode"
                required
                label="邀请码"
                :rules="[{ required: true, message: '请填写6位邀请码' }]"
                placeholder="请填写邀请码"
                :disabled="isdisabled"
              />
    <van-field v-if="showHospName"
                v-model="registerData.nowHospName"
                required
                label="绑定企业"
                placeholder="请填写绑定企业"
                :disabled="isdisabled"
              />
  </van-form>
</van-cell-group>
<br/>
<van-button color="linear-gradient(to right, #f67f34, #d55809)" block size="large" @click="getData">下一步</van-button>
</template>
<script>
import { ref, toRefs, reactive, onMounted } from "vue";
import { postHospAndMobile,getPersonInit} from "../../api/register";
import request from '../../utils/request';
import { useRouter } from "vue-router";
import { showDialog } from "vant";
export default {
  setup() {
    const active = ref(0);
    const result = ref("");
    const showPicker = ref(false);
    const router = useRouter();
    const isdisabled =ref(false)
    const showHospName=ref(false)

    const state = reactive({
      registerData: {
        hospitalName: "",
        hospitalCode: "",
        realName: "",
        nowHospName: "",
        nowHospCode: "",
        phone: "",
        idCard: "",
        smsBindingCode: "",
        informed: "",
        isDoctor: "",
        pageTabId: "0",
      },
    });
    const hospitalInfo = reactive({
      hospitalInfoVo: {
        hospitalId: "",
        hospitalName: "",
      },
    });
    const getData = () => {
        console.log(state.registerData.nowHospCode)
        state.registerData.pageTabId="0";
        postHospAndMobile(state.registerData).then((res) => {
            console.log("提交的结果值"+res);
            if(res.data.code ==20000){
                router.push(res.data.redirectUrl);
              }else{
                showDialog({
                    title: "错误提醒",
                    message: res.data.message,
                    theme: "round-button",
                }).then(() => {
                  
                });
              }
         });
        
    };
    onMounted(() => {
      console.log("页面打开");
      const exp=router.currentRoute.value.query.hospId;
       if (exp== undefined || exp == null||exp == '')
        {
          console.log("不是扫码进入,或首次未绑定的");
          getPersonInit().then((res2) => {
            console.log(state.registerData);
            state.registerData = res2.data.data;
          });
        }else{
          request.get('/wxmanager/person/getHospitalInfo', {
                    params: {
                        hospId: exp
                    }
                  }).then((res) => {
                    console.log(res.data.data);
                    hospitalInfo.hospitalInfoVo=res.data.data;
                    if(res.data.code == 20000){
                        state.registerData.nowHospCode=hospitalInfo.hospitalInfoVo.hospitalId;
                        state.registerData.nowHospName=hospitalInfo.hospitalInfoVo.hospitalName;
                        isdisabled.value=true;
                        showHospName.value=true;
                    }
                  })
        }
    });
    return {
      active,
      result,
      showPicker,
      isdisabled,
      getData,
      hospitalInfo,
      showHospName,
      ...toRefs(state),
    };
  },
};
</script>
<style lang="less" scoped>
#level {
  height: 400px;
  width: 100%;
}

#risk {
  height: 400px;
  width: 100%;
}

.van-cell {
  border-radius: 30rpx;
  margin: 40rpx 0 0 0;
}

/* 去除单元格cell下边框 */
.van-cell:after {
  border-bottom: none !important;
  border-bottom-style: none !important;
}

/* 单元格标题title */
.van-cell .van-cell__title {
  color: #7186e1;
}

/* 标题下方label */
.van-cell .van-cell__label {
  color: #000;
  font-weight: 500;
}

.textIndentation {
  font-size: 12px;
  text-align: left;
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  width: 500px;
  height: 400px;
}

.text3Indentation {
  text-align: left;
  font-weight: bold;
  font-size: 12px;
}

.text2Indentation {
  text-align: left;
  font-size: 12px;
}

.content {
  padding: 16px 16px 160px;
}
.notice-swipe {
  height: 40px;
  line-height: 40px;
}
.video {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.video-container {
  position: relative;
  width: 95%;
  clear: both;
  margin: 0 auto;
}
</style>
